var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReclamo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5H14.0117M14 8.16667V12.8333M25.6667 19.8333C25.6667 20.4522 25.4209 21.0457 24.9833 21.4832C24.5457 21.9208 23.9522 22.1667 23.3334 22.1667H7.96604C7.34725 22.1668 6.75386 22.4127 6.31637 22.8503L3.74737 25.4193C3.63153 25.5352 3.48394 25.614 3.32328 25.646C3.16261 25.6779 2.99608 25.6615 2.84473 25.5988C2.69339 25.5362 2.56403 25.43 2.47301 25.2938C2.38199 25.1576 2.3334 24.9975 2.33337 24.8337V5.83333C2.33337 5.21449 2.57921 4.621 3.01679 4.18342C3.45438 3.74583 4.04787 3.5 4.66671 3.5H23.3334C23.9522 3.5 24.5457 3.74583 24.9833 4.18342C25.4209 4.621 25.6667 5.21449 25.6667 5.83333V19.8333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReclamo);
export default __webpack_public_path__ + "static/media/reclamo.723eb6d392edecf3b4207d3616553c00.svg";
export { ForwardRef as ReactComponent };